import { useState } from 'react';

import { GridSortModel, GridPaginationModel } from '@mui/x-data-grid';

import { useGetOrders } from 'src/api/hooks/api-hooks';

export function useOrders({
  initialPaginationModel,
  initialSortModel,
}: {
  initialPaginationModel?: GridPaginationModel;
  initialSortModel?: GridSortModel;
} = {}) {
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>(
    initialPaginationModel ?? { pageSize: 25, page: 0 }
  );
  const [sortModel, setSortModel] = useState<GridSortModel>(initialSortModel ?? []);

  const { data, isLoading, error } = useGetOrders(paginationModel, sortModel[0]);

  return {
    orders: data?.data ?? [],
    ordersTotalCount: data?.totalRecords ?? 0,
    ordersTotalPages: data?.totalPages ?? 0,

    fetchOrdersLoading: isLoading,
    fetchOrdersError: error,

    paginationModel,
    sortModel,

    setSortModel,
    setPaginationModel,
  };
}
